const BusinessState = {
    businessStates: [],
    businesses: [],
    business: {}
};

export default BusinessState;